import { IKnmActType } from '../../../APIPackage/CatalogsModule/interfaces/IKnmActType';
import { IKnmActTypeSelectOption } from '../interfaces/IKnmActTypeSelectOption';

export function createKnmActTypeSelectOption(reason: IKnmActType): IKnmActTypeSelectOption {
  return {
    ...reason,
    label: reason.name,
    value: reason.id,
  };
}
